import React from 'react';
import '../components-css/about-course.scss'
import {forWhom, whyThisCourse} from "../data/mock-date";
import MiniHeaders from "./mini-headers";
import DoneSharpIcon from '@mui/icons-material/DoneSharp';

const AboutCourse = () => {
    return (
        <>
            <div className={'blocks-wrapper'}>
                <div>
                    <MiniHeaders headerName={'Ու՞մ համար է այս դասընթացը'} fontSize={22}/>
                    <ul className={'features'}>
                        {forWhom.map((item, index) => (
                            <li key={index} className="list-item">
                                <DoneSharpIcon sx={{ color: '#9f0f91'}}/><p>{item}</p>
                            </li>
                        ))}
                    </ul>
                    <br/>
                </div>
            </div>
            <div className={'blocks-wrapper'}>
                <MiniHeaders headerName={'Ինչու՞ ընտրել հենց այս դասընթացը'} fontSize={19}/>
                <ul>
                    {whyThisCourse.map((item, index) => (
                        <li key={index} className="list-item">
                            <p>{item}</p>
                        </li>
                    ))}
                </ul>
                <div className={'why-this-course'}/>

            </div>
        </>
    );
};

export default AboutCourse;
